import * as actionTypes from '../actions/actionsTypes';

const initialState = {
    animalPartId: null,
    name: null,
    img: null,
    img2:null,
    textSvis: null,
    textVod: null,
    show: false,
    showModal: false,
    modalImg: null
   
};

const reducer = ( state = initialState, action) => {
    switch (action.type){
        case actionTypes.SET_TEXT:
        return {
            ...state,
            animalPartId: action.id,
            name: action.name,
            img: action.img ,
            img2:action.img2,
            textSvis: action.textSvis ,
            textVod: action.textVod ,
            show:true
        }
        case actionTypes.SET_DEFAULT_TEXT_ON:
        return {
            ...state,
            animalPartId: null,
            name: 'Základní dělení - úvod',
            img: null,
            textSvis: null,
            textVod: null,
            show: false,
        }
        case actionTypes.SHOW_MODAL:
        return {
            ...state,
            showModal:true,
            modalImg:action.modalImg
        }
        case actionTypes.CLOSE_MODAL:
        return {
            ...state,
            showModal:false
        }
       
      
        default: return state;
    }
}

export default reducer;